import config from '../config/config';
import {logout} from './LogoutService';
import {jwtToken as getJwtToken} from './services/LoginService';
import {
    BASEURL,
    SERVICE_DOWN_CODES,
    SERVICE_DOWN_PREV_URL_KEY
} from "../constants/constants";
import axios from "axios";

function baseOptions(endpoint, opts = {}) {
    const jwtToken = getJwtToken();

    endpoint = endpoint.replace(/\/+/g, '/');

    const url = config.API_BASE_URL + endpoint;

    const headers = {
        'Content-Type': opts.file ? 'multipart/form-data' : 'application/json',
    };

    if (!opts.publicRequest) {
        headers.Authorization = 'Bearer ' + jwtToken;
    }

    return { url, headers };
}

function handleErrorResponse(error, opts = {}) {
    const status = error.response?.status;
    const responseData = error.response?.data;

    if (responseData) {
        if (opts.checkAuthorization
            && (status === 401 || status === 403)
            && !responseData.errorCode
        ) {
            logout();
        }

        if (SERVICE_DOWN_CODES.includes(status)) {
            localStorage.setItem(SERVICE_DOWN_PREV_URL_KEY, window.location.pathname);
            window.location.href = `${BASEURL}/service-down`;
        }
    }

    throw error;
}

// Retry transient 500 errors once with a short delay [SEPAHELD-FRONTEND-1K]
function withRetry(requestFn, opts) {
    return requestFn().catch(error => {
        const status = error.response?.status;
        if (status >= 500 && status < 600) {
            return new Promise((resolve) => setTimeout(resolve, 1000))
                .then(() => requestFn())
                .catch(retryError => handleErrorResponse(retryError, opts));
        }
        return handleErrorResponse(error, opts);
    });
}

export function get(endpoint, opts = {checkAuthorization: true}) {
    return withRetry(
        () => axios({ method: 'GET', ...baseOptions(endpoint, opts) }),
        opts
    );
}

export function post(endpoint, body, opts = {checkAuthorization: true}) {
    return withRetry(
        () => axios({ method: 'POST', ...baseOptions(endpoint, opts), data: opts.file ? undefined : body }),
        opts
    );
}

export function put(endpoint, body, opts = {checkAuthorization: true}) {
    return withRetry(
        () => axios({ method: 'PUT', ...baseOptions(endpoint, opts), data: opts.file ? undefined : body }),
        opts
    );
}

export function del(endpoint, opts = {checkAuthorization: true}) {
    return withRetry(
        () => axios({ method: 'DELETE', ...baseOptions(endpoint, opts) }),
        opts
    );
}
